import React, { useState } from 'react';
import axios from 'axios';

const Newsletter = () => {
  const [formData, setFormData] = useState({
    formType: 'newsletter',
    email: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Fallback to 5000 if env is missing


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        await axios.post(`${apiUrl}/submit`, formData);
      alert('Form submitted successfully!');
      setFormData({ formType: 'newsletter', email: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative py-24 newsletter bg-cover bg-center bg-no-repeat">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
        {/* Section Heading */}
        <h3 className="text-3xl font-bold mb-4">
          Stay Updated
          <span className="text-secondary"> with Us</span>
        </h3>
        <p className="mb-8">
          Subscribe to our newsletter for the latest updates, tips, and insights.
        </p>

        {/* Subscribe Form */}
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-4 max-w-md mx-auto">
          <input
            type="email"
            id="email"
            placeholder="Enter your email address"
            className="w-full sm:flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#B2D190]"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <button
            type="submit"
            className="px-6 py-2 bg-primary text-white font-semibold rounded-md hover:bg-secondary hover:text-primary transition-colors"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Subscribe'}
          </button>
        </form>
        <p className="text-xs text-gray-200 mt-4">
          We respect your privacy and will never share your email address.
        </p>
      </div>
    </div>
  );
};

export default Newsletter;
